export default __webpack_public_path__ + "static/media/M23.cc97ed40.svg";